var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportContentModal',{attrs:{"card":_vm.selectedPreviewCard,"page":_vm.reportingPage},on:{"ok":function($event){return _vm.$emit('ok')},"cancel":function($event){return _vm.$emit('cancel')}}})}
var staticRenderFns = []

export { render, staticRenderFns }